import { render, staticRenderFns } from "./BuildingApartment.vue?vue&type=template&id=153e57d6&"
import script from "./BuildingApartment.vue?vue&type=script&lang=ts&"
export * from "./BuildingApartment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('153e57d6')) {
      api.createRecord('153e57d6', component.options)
    } else {
      api.reload('153e57d6', component.options)
    }
    module.hot.accept("./BuildingApartment.vue?vue&type=template&id=153e57d6&", function () {
      api.rerender('153e57d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/building/components/BuildingApartment.vue"
export default component.exports